var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoggedIn)?_c('LoggedInLayout',{attrs:{"guide":_vm.guide}}):_c('LoggedOutLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }